// extracted by mini-css-extract-plugin
export default {"article":"ArticlePage_article__RT0VY","title":"ArticlePage_title__aijic","content":"ArticlePage_content__g9fya"};